import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Services from "./sections/Services";
import Experience from "./sections/Experience";
import Founder from "./sections/Founder";
import Contact from "./sections/Contact";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Experience />
      <Founder />
      <Testimonials />
      <Contact />
      <Footer />
    </div>;
}